import { Component, Inject, OnInit, OnDestroy, PLATFORM_ID } from '@angular/core';
import { Location } from '@angular/common';
import { isPlatformBrowser } from '@angular/common';
import { LoaderService } from 'src/app/core/loader-services/loader.service';
@Component({
  selector: 'app-technical-error',
  templateUrl: './technical-error.component.html',
  styleUrls: ['./technical-error.component.scss']
})
export class TechnicalErrorComponent implements OnInit, OnDestroy {

  showTechnicalErrorPageFound: boolean = false;

  constructor(
    private loc: Location,
    @Inject(PLATFORM_ID) private platformId: object,
    private loaderService: LoaderService
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.showTechnicalErrorPageFound = true;
    }
  }

  reload() {
    this.loaderService.startManualLoad(this);
    setTimeout(() => {
      if (window.navigator.onLine) {
        this.loc.back();
      }
      this.loaderService.stopManualLoad(this);
    }, 400);
  }

  ngOnDestroy(): void {
    this.loaderService.stopManualLoad(this);
  }
}
